import React, { Component } from 'react'
import TimeLine from "react-gantt-timeline";

import produce from "immer"
import View from 'react-flexbox'
const traducao = {
    id: "uid",
    start: "dataInicio",
    end: "dataFimPrevista1",
    name: "titulo",
    color: "corGant",
}

const config = {
    taskList: {
        task: {
            style: {
                backgroundColor: "grey",
                color: "white"
            },
            renderItem: (item) => "oi kk"
        }

    }
};
export default class GantComponent extends Component {
    constructor(props) {
        super(props);
        this.updateItem = this.updateItem.bind(this)
        let d1 = new Date();
        let d2 = new Date();
        d2.setDate(d2.getDate() + 5);
        let d3 = new Date();
        d3.setDate(d3.getDate() + 8);
        let d4 = new Date();
        d4.setDate(d4.getDate() + 20);

        let data = [
            {
                id: 1,
                start: d1,
                end: d2,
                name: "Demo Task 1"
            },
            {
                id: 2,
                start: d3,
                end: d4,
                name: "Demo Task 2",
                color: "orange"
            }
        ];

        this.state = { data: data, links: [] };
    }
    genID() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (
            S4() +
            S4() +
            "-" +
            S4() +
            "-4" +
            S4().substr(0, 3) +
            "-" +
            S4() +
            "-" +
            S4() +
            S4() +
            S4()
        ).toLowerCase();
    }
    createLink(start, end) {
        return {
            id: this.genID(),
            start: start.task.id,
            startPosition: start.position,
            end: end.task.id,
            endPosition: end.position
        };
    }
    onUpdateTask = (item, props) => {


        item.start = props.start;
        item.end = props.end;
        // console.log('item', item);

        // this.setState({ data: [...this.state.data] });
        this.updateItem(item)
    };
    onCreateLink = item => {
        let newLink = this.createLink(item.start, item.end);
        alert("Nao implementado")
        // this.setState({ links: [...this.state.links, newLink] });
    };

    updateItem(item) {
        const { input: { value, onChange } } = this.props;
        const nextState = produce({ value: value || [] }, draftState => {
            draftState.value.forEach(element => {
                if (element[traducao.id] === item.id) {
                    element[traducao.start] = item.start
                    element[traducao.end] = item.end
                    element[traducao.name] = item.name
                    element[traducao.color] = item.color

                }
            });

        })

        onChange(nextState.value);
    }
    getRandomColor() {
        var letters = "0123456789ABCDEF";
        var color = "#";
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color
    }
    calcFim(item, inicio) {
        let hojeFim = new Date();
        hojeFim.setDate(inicio.getDate() + 1);
        return hojeFim;
    }
    render() {
        const { input: { value, onChange } } = this.props;
        let hoje = new Date();
        let hojeFim = new Date();
        hojeFim.setDate(hojeFim.getDate() + 1);
        let array = value ? value.map(item => {
            // let cor = this.getRandomColor();
            // if (item[traducao.color]) { 
            //     cor = item[traducao.color];
            // }
            // console.log('cor',cor);
            
            return {
                original: item,
                id: item[traducao.id],
                start: item[traducao.start] || hoje,
                end: item[traducao.end] || this.calcFim(item, item[traducao.start] || hoje),
                name: item[traducao.name],
                
                // color: cor,
            }
        }) : []
        return (
            <View style={{ width: 0, }}>
                {/* <TimeLine
                    data={array}
                    links={this.state.links}
                    onUpdateTask={this.onUpdateTask}
                    onCreateLink={this.onCreateLink}
                    config={config}
                /> */}
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Gant/components/GantComponent/GantComponent.js